import { defineNuxtPlugin } from '#app'
import { DialogController, DialogControllerInternal } from '../composables/DialogController'

export default defineNuxtPlugin((nuxtApp) => {
  const { show, hide } = DialogControllerInternal.useInternal()

  const dialog = {
    show,
    hide
  }

  nuxtApp.provide('dialog', dialog)

  nuxtApp.vueApp.directive('dialog-target', {
    mounted(el: HTMLElement, binding: any) {
      const { value, arg, modifiers } = binding
      const targetId = value || arg

      if (targetId) {
        if (modifiers.hide) {
          el.onclick = () => dialog.hide(targetId)
        } else {
          el.onclick = () => dialog.show(targetId)
        }
      }
    }
  })
})
